import { render, staticRenderFns } from "./InterestHistory.vue?vue&type=template&id=23f9f2ce&scoped=true&"
import script from "./InterestHistory.vue?vue&type=script&lang=js&"
export * from "./InterestHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9f2ce",
  null
  
)

export default component.exports